var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNodes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.5 -284.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-224,284.5v6.667h2.56V308.5h1.68V291.167h2.427V284.5Zm5,5h-3.333v-3.333H-219Z",
    transform: "translate(2.167 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.287,294.513a3.268,3.268,0,0,0,.453-1.68,3.335,3.335,0,0,0-3.333-3.333,3.335,3.335,0,0,0-3.333,3.333,3.335,3.335,0,0,0,3.333,3.333,3.326,3.326,0,0,0,1.693-.467l2.147,2.133v9h1.667v-9.68Zm-2.88-.013a1.667,1.667,0,0,1-1.667-1.667,1.667,1.667,0,0,1,1.667-1.667,1.667,1.667,0,0,1,1.667,1.667A1.667,1.667,0,0,1-227.167,294.5Z",
    transform: "translate(0 1.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213.793,286.5a3.335,3.335,0,0,0-3.333,3.333,3.326,3.326,0,0,0,.467,1.693l-1.96,1.96v14.347h1.653V294.18l1.48-1.48a3.326,3.326,0,0,0,1.693.467,3.335,3.335,0,0,0,3.333-3.333A3.335,3.335,0,0,0-213.793,286.5Zm0,5a1.667,1.667,0,0,1-1.667-1.667,1.667,1.667,0,0,1,1.667-1.667,1.667,1.667,0,0,1,1.667,1.667A1.667,1.667,0,0,1-213.793,291.5Z",
    transform: "translate(3.96 0.667)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNodes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nodes.de2b261122311a6e675af3c3cdee1553.svg";